(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    // ── Reading-progress bar ───────────────────────────────────
    (function () {
      var bar = document.getElementById('pv-progress');
      if (!bar) return;
      var ticking = false;
      function update() {
        var h = document.documentElement;
        var max = (h.scrollHeight - h.clientHeight) || 1;
        var pct = Math.min(100, Math.max(0, (h.scrollTop || document.body.scrollTop) / max * 100));
        bar.style.width = pct + '%';
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
      }, { passive: true });
      update();
    })();

    // ── Scroll reveal (soft fade-up) ───────────────────────────
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pv-in'); io.unobserve(e.target); } });
        }, { threshold: 0.08 })
      : null;
    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('pv-in');
    });

    // ── Clone the trust-pill row into the footer slot ──────────
    (function () {
      var top = document.querySelector('nav.pv-trust-top');
      if (!top) return;
      var html = top.innerHTML;
      document.querySelectorAll('[data-pv-trust-clone]').forEach(function (c) { c.innerHTML = html; });
    })();

  });
})();
